import React from 'react'

import { Badge } from 'reactstrap'

import { formatDateByLanguage } from 'utils/formatters'
import Icon from 'common/Icon'

import { TableListStatus, TableListStatusItem } from 'components/Case/CaseDetail/TableList'

export default ({ resource, piItem }) => {
  const { status,languageCode } = piItem

  return (
    <TableListStatus>
      <TableListStatusItem>
        <div className="align-items-center">
          <Badge color={status.purchaseInvoiceSentToAccounting ? 'success' : 'danger'}>
            <Icon icon={status.purchaseInvoiceSentToAccounting ? 'done' : 'clear'} className="md-12" />
          </Badge>
          <span className="ms-2 me-1">{resource.InvoiceSentToAccounting}</span>
        </div>
        {status.purchaseInvoiceSentToAccounting && (
          <small className="text-muted">
            <em>{formatDateByLanguage(status.datePurchaseInvoiceSentToAccounting, 'DD MMMM YYYY H:mm',languageCode)}</em>
          </small>
        )}
      </TableListStatusItem>
    </TableListStatus>
  )
}
